import { SvgIcon, SvgIconProps } from "@material-ui/core";
import React from "react";
import { ReactComponent as Trophy } from "./trophy.svg";

const IconTrophy: React.FC<SvgIconProps> = (props) => {
    return <SvgIcon {...props} component={Trophy} />;
};

export { IconTrophy };
